import { useContext, useEffect, useState, type FC } from "react";
import { useLocation } from "react-router-dom";
import { getVerificationEmail } from "../services/AuthApi";
import { LoadingContext } from "../contexts/LoadingContext";

interface VerifyPageProps {}

const VerifyPage: FC<VerifyPageProps> = ({}) => {
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) return;
    setIsLoading(true);
    getVerificationEmail(token!)
      .then((v) => v.json())
      .then((res) => {
        setIsVerified(true);
      })
      .catch((error) => {
        setError(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [token]);

  if (!token) {
    return (
      <div className="not-found">
        <div className="flex flex-col items-center justify-center h-screen">
          <h1 className="text-center text-2xl font-semibold uppercase text-red-500">
            No Token Provided
          </h1>
          <p className="text-center text-lg">
            The page you are looking for does not exist.
          </p>
        </div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="not-found">
        <div className="flex flex-col items-center justify-center h-screen">
          <h1 className="text-center text-2xl font-semibold uppercase text-red-500">
            Error
          </h1>
          <p className="text-center text-lg">{error}</p>
        </div>
      </div>
    );
  }
  return (
    <div className="not-found flex justify-center">
      <div className="flex flex-col items-center justify-center h-screen w-[60%]">
        <h1 className="text-center text-2xl font-semibold uppercase text-red-500">
          Your Email Has Been Verified!
        </h1>
        <p className="text-center text-lg">
          Welcome to {process.env.REACT_APP_NAME}! Your email has been
          successfully verified, and your account is now active. Start exploring
          our wide range of products and enjoy a seamless shopping experience.
        </p>
        <p className="text-center text-lg font-bold">Thank you for joining us!</p>
      </div>
    </div>
  );
};
export default VerifyPage;
